<template lang="pug">
  div
    div.toolbar
      div.line
        h1.title Реестр договоров
        //div.view-panel
          button.view-panel__button.view-table.active
          button.view-panel__button.view-chart
          button.view-panel__button.view-map
      div.line
        div.parameter.parameter--right
          select.reg-operator
            option Региональный оператор 1
            option Региональный оператор 2
        form.search
          input(type="search" placeholder="")
        div.actions-panel
          //button.actions-panel__button.btn-columns(title="Отобразить столбцы")
          //div.filter-popup(style="display: none")
            div.item
              input.checkbox(type="checkbox")
              label 123
            div.item
              button Выбрать все
          //button.actions-panel__button.btn-refresh(title="Актуализация таблицы")
          //button.actions-panel__button.btn-delete(title="Удаление")
          button.actions-panel__button.btn-add.green(title="Добавление")



    div.content
      //div.search-result
                      span Найдено 34 объекта из 326 500
      div.table
        table(cellspacing="0")
          thead
            tr
              th Региональный оператор
              th № Договора
              th Срок действия
              th Заказчик
              th Тип заказчика
              th Адрес регистрации
              th

          tbody
            tr
              td Региональный оператор 1
              td 341-КО
              td 05.12.2017 - 04.12.2018
              td ООО "Антек"
                div ИНН: 6627015279
              td Управляющая организация
              td г. Ревда, ул. Чайковского, д.4, к. а
              td
                div.buttons
                  button.row-edit
                  button.row-delete

    div.footer-nav
      div.actions-filter-panel
      //  button.actions-filter-panel__button.default.download Скачать
      div.paginator
        span Показывать по
        select
          option 10
          option 25
          option 50
          option 100
        div.page-nav
          span.navigate.prev
          input(type='text' value="1")
          span из 1
          span.navigate.next



</template>

<script>
  export default {};

</script>

<style lang="scss">
  /*@import "./../../../assets/styles/content";*/

  /* закоментил  */
  /* @import "./../../../assets/styles/listComponent"; */
</style>
